import { Accordion, Stepper, ThemeIcon } from "@mantine/core";
import SummaryItem from "./SummaryItem";
import { IconSend } from "@tabler/icons-react";
import { useLanguage } from "../../../../../../../stores/LanguageStore";
import { useSessionStore } from "../../../../../../../stores/UserStore";

const SummaryGroup = ({ campaign, isFirst }) => {
  const lang = useLanguage((s) => s.language);
  return (
    <Accordion
      variant="contained"
      mb={16}
      defaultValue={isFirst ? `${campaign.programmation_id}` : null}
    >
      <Accordion.Item value={`${campaign.programmation_id}`}>
        <Accordion.Control
          icon={
            <ThemeIcon variant="subtle">
              <IconSend />
            </ThemeIcon>
          }
          bg={
            useSessionStore.getState().reseller?.name === "Magileads"
              ? "primary.2"
              : "primary.0"
          }
          h={64}
        >
          {campaign.programmation_id ? (
            <>
              {lang.workflow_preview.campaign} : {campaign.workflow_name} #{campaign.programmation_id}
            </>
          ) : (
            <>{lang.leads.manual_sending}</>
          )}
        </Accordion.Control>

        <Accordion.Panel>
          <Stepper
            active={0}
            iconSize={28}
            mt={16}
            size="sm"
            radius={"lg"}
            styles={{ stepIcon: { border: "none", background: "none" } }}
            orientation="vertical"
          >
            {campaign.history.map((item, index) => (
              <SummaryItem
                key={item?.id || index}
                item={item}
                isLast={index === campaign.history.length - 1}
                campaignId={campaign.programmation_id}
                // isOutside={!!outside}
              />
            ))}
          </Stepper>
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
};

export default SummaryGroup;
